// extracted by mini-css-extract-plugin
module.exports = {"card_action":"ActionBlock_card_action__2TX0E","content_wrapper":"ActionBlock_content_wrapper__1WGQE","icon_wrapper":"ActionBlock_icon_wrapper__2ZFM1"};